import md5 from "md5";
import { loginWap } from "@/views/api/user";

// const TokenKey = "Admin-Token";
const InformationKey = "info";
const FlagKey = "flag";
const LanguageKey = "language";
const BackGroundKey = "BackGround";
export function setToken(token) {
  return localStorage.setItem(InformationKey, JSON.stringify(token));
}

export function getToken() {
  if (localStorage.getItem(InformationKey))
    return JSON.parse(localStorage.getItem(InformationKey));
  return {
    vga: "",
    token: "",
    fullname: ""
  };
}

export const getInfo = () => localStorage.getItem(InformationKey);

export const setInfo = () => localStorage.setItem(InformationKey);

export const getFlag = () => localStorage.getItem(FlagKey);

export const setFlag = flag => localStorage.setItem(FlagKey, flag);

export const removeFlag = () => localStorage.removeItem(FlagKey);

export const getLanguage = () => localStorage.getItem(LanguageKey);

export const setLanguage = lang => localStorage.setItem(LanguageKey, lang);

export const removeLanguage = () => localStorage.removeItem(LanguageKey);

export async function setupLoginWap(self) {
  let currentUrl = window.location.host;
  if (currentUrl == "localhost:8080") {
    if (!checkTokenExists()) {
      if (checkSignData(self)) {
        //call api login get token
        let dataLogin = {
          phone: self.$router.history.current.query.phone,
          signdata: renderSignData(self.$router.history.current.query.phone)
        };
        await loginWap(dataLogin).then(res => {
          if (res.error_code === 200) {
            localStorage.setItem(InformationKey, JSON.stringify(res.data.data));
            window.location.href = window.location.href;
          }
        });
      }
    }
  }
}

export function renderSignData(phone) {
  let secretKey = process.env.VUE_APP_SECRET_KEY;
  return md5(secretKey + phone);
}

export function setInfoLogin(info) {
  localStorage.setItem(
    "info",
    JSON.stringify({
      vga: info.vga,
      token: info.token,
      fullname: info.fullname
    })
  );
}

export function checkTokenExists() {
  let token = getToken().token;
  return !!token.length;
}

export function checkSignData(self) {
  let params = self.$router.history.current.query;
  if ("signdata" in params && "phone" in params) {
    let signdata = params.signdata;
    let phone = params.phone;
    if (signdata.length && phone.length) {
      let signDataRender = renderSignData(phone);
      return signDataRender === signdata;
    }
  } else {
    return false;
  }
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

export function setBackGround(info) {
  return localStorage.setItem(BackGroundKey, JSON.stringify(info));
}

export function getBackGround() {
  if (localStorage.getItem(BackGroundKey))
    return JSON.parse(localStorage.getItem(BackGroundKey));
  return {
    c_cyan_background: "#00aea9",
    c_white_background: "#ffffff",
    c_inherit_background: "#b7b7b7",
    c_white_text_important: "#ffffff",
    c_white_text_important_hover: "#ffffff",
    c_white_text_important_focus: "#ffffff",
    c_red_text: "#de003f",
    c_white_text: "#ffffff",
    c_text_main: "#00aea9",
    c_error_text: "#de003f",
    c_divider_text: "#88d9d7",
    c_primary_text: "#00aea9",
    c_initial_text: "#272626",
    c_inherit_text: "#b7b7b7",
    c_link_text: "#177dc5",
    c_link_text_hover: "#177dc5",
    c_link_text_focus: "#177dc5",
    c_button_main: "#00aea9",
    c_border: "#daa520",
    c_button_search: "#daa520",
    c_button_text: "#de003f",
    c_header: "#00aea9",
    c_banner: "#00aea9",
    c_footer: "#00aea9",
    c_menu_header: "#ffffff",
    c_menu_footer: "#ffffff",
    colorMain: "#00aea9",
    logo: "https://cdn.vcallid.com/e95dc8cb-eed1-42b9-9127-3d2919fc42f6.png",
    logo_footer:
      "https://cdn.vcallid.com/e95dc8cb-eed1-42b9-9127-3d2919fc42f6.png"
  };
}

export const removeBackGround = () => localStorage.removeItem(BackGroundKey);
